import React from "react";

export default function Instructor(props) {
  return (
    <div className="p-3 md:p-4 bg-white rounded-lg shadow-box">
      <div className="flex flex-row justify-start items-center mb-3">
          <div 
            className="rounded-full h-14 w-14 bg-no-repeat bg-cover"
            style={{backgroundImage: `url(${props.photo})`}}>
          </div>
        <div className="ml-3">
          <p className="text-xl text-ia-indigo-dark font-medium mb-1">{props.name}</p>
          <p className="text-xs text-gray-500 mb-0">{props.title}</p>
        </div>
      </div>
      <p>{props.about}</p>
    </div>
  )
}